import { render, staticRenderFns } from "./NovelDetail.vue?vue&type=template&id=bb3a3758&scoped=true&"
import script from "./NovelDetail.vue?vue&type=script&lang=ts&"
export * from "./NovelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NovelDetail.vue?vue&type=style&index=0&id=bb3a3758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3a3758",
  null
  
)

export default component.exports